export const VideosSection = () => {
  return (
    <div className="dark:bg-slate-900 bg-slate-50 py-4 sm:py-16 px-6">
      <h1
        id="videos"
        className="mb-8 text-2xl sm:text-4xl font-extrabold tracking-tight text-center dark:text-white text-slate-900"
      >
        Videos
      </h1>
      <h2 className="text-lg sm:text-2xl font-bold text-center mt-6 mb-6 dark:text-slate-300 text-slate-600">
        Education Sessions 
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 max-w-7xl mx-auto">
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/0UqS_jxWcmA"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
      </div> 
      <h2 className="text-lg sm:text-2xl font-bold text-center mt-12 mb-6 dark:text-slate-300 text-slate-600">
        Myers Briggs
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 max-w-7xl mx-auto">
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/A0tpV6TyIU4"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/3LXuQX7WXF8"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/Bb_pjNWvjvs"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/0k9ZiadK8ZI"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/XsFcpV9lmtk"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
      </div> 
      <h2 className="text-lg sm:text-2xl font-bold text-center mt-12 mb-6 dark:text-slate-300 text-slate-600">
        Fun Videos
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 max-w-7xl mx-auto">
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/JJkQzsmZTaE"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/-X6W5RgmaA8"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/JvfFTekH2dw"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
        <div className="aspect-video relative rounded-2xl overflow-hidden shadow-lg bg-slate-100 dark:bg-slate-800">
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/dfDoGMWoIW8"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        ></iframe>
        </div>
      </div>
    </div>
  );
};
